<template>
  <div id="phone-container">
    <div class="daylv">
     <div class="charts" />
     <div class="chong">
         <div class="chonglv">
            <div class="yellow"> {{recaptureData.recaptured_rate}}</div>
            <div class="gary">重新使用率</div>
         </div>
         <img src="./img/line2.png" alt="" >
         <div class="chongchang">
            <div class="yellow"> {{useTime}}</div>
            <div class="gary">重新使用时长</div>
         </div>
       </div>
    </div>
    <div class="worktime">
      <div class="swiper">
      <swiper ref="mySwiper" :options="swiperOption">
      <swiper-slide
         v-for="(item, i1) in areasByAreaId"
        :key="i1"
        class="swiper-slide"
      >
      <div class="zhan">
        <div class="write">{{item.area_name}}</div>
        <div class="gary">占用率 {{item.avg_working_occupied_rate.value*100}}%</div>
      </div>
      <div class="aaa"/>
      <div class="bbb"  :style="{width: `${item.avg_working_occupied_rate.value*100}%`}"/>

        <!-- <meeting-item :item="item" /> -->
       </swiper-slide>
       </swiper> 
      </div>
    </div>
   
  </div>
</template>

<script>
import freeIcon from "../../static/img/landline.png";
import occupiedIcon from "../../static/img/phone.png";
import echarts from "echarts"
import config from "../config";
import * as api from "../services/api";
import dayjs from "dayjs";

export const OCCUPANCY_STATES = [
  // {
  //   id: "occupancy_not_installed",
  //   icon: freeIcon,
  //   color: "rgba(50, 232, 94, 0.8)",
  // },
  {
    id: "occupancy_free",
    icon: freeIcon,
    color: "rgba(50, 232, 94, 0.8)",
  },
  {
    id: "occupancy_occupied",
    icon: occupiedIcon,
    color: "rgba(252, 43, 8, 0.8)",
  },
];

export default {
  name: "PhoneBooth",
  props: {
    areas: {
      type: Array,
      default: () => [],
    },
    // stsUsageRate:{
    //   type:Array,
    //   default:()=>[]
    // },
    recaptureData:{
      type:Object,
      default:()=>{}
    },
    areasByAreaId:{
      type:Array,
      default:()=>[]
      
    }
  },
  data: function () {
    return {
      stsUsageRate:[],
        nume:[],
        swiperOption: {
        //显示分页
        pagination: {
          el: ".swiper-pagination",
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
        // 循环方向
        direction: "vertical",
        slidesPerView: 5,
        slidesPerGroup: 5,
        loopFillGroupWithBlank: true,
        spaceBetween: 10,
        speed: 800,
        height: 200,
        // width:200
      },
    };
  },
  computed:{
     swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    useTime(){
      return (this.recaptureData.total_recaptured_duration/3600).toFixed(2)
    }
  },
  created(){
       this.getMeetingUsageRate()
      //  this.swiperr()
      
  },
  mounted() {
    console.log("**** phone booths", this.areas);
     setInterval(() => {
     this.getMeetingUsageRate()
    }, 10 * 60 * 1000); // load data every 10 minut

  },
  methods: {
     swiperr(){
     if(this.areasByAreaId.length < 6){
          this.swiperOption.loop=false
      }
    },
    numb(){
       let nums=this.stsUsageRate.map(obj=> this.retainDecimals(obj.thisMonth))
       this.nume= nums.map(element => {
         return  Number(element)
       });
     },
     getMeetingUsageRate:async function(){
      const resp= await api.getMeetingUsageRate({
         location_id:config.locationId,
         start_date: dayjs().subtract('1','week').format('YYYY-MM-DD'),
         end_date: dayjs().format('YYYY-MM-DD'),
         include_last:true
       })
       const {stats,last_month_stats} = resp.data
       console.log(stats,last_month_stats);
       const stsUsageRate = stats.map((d, index) => ({
              date: dayjs(d.date).format('MM-DD'),
              thisMonth: d.usage_rate,
              // lastMonth: last_month_stats[index].usage_rate || 0,
       }));
       this.stsUsageRate = stsUsageRate
       this.numb()
       this.drawChart()
    },
    retainDecimals(data = 0, num = 2) {
        return parseFloat(data).toFixed(num);
    },
    drawChart() {
      console.log(123324);
        let myEchart = this.$echarts.init(document.querySelector('.charts'));
        let option = {
        grid: {
          top: '2%',
          left: '10%',
          right: '4%',
          bottom: '10%'
          // scontainLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: { show: false },
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
          nameLocation: "middle",
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisTick: { show: false },
          // splitLine: {
          //   show: false
          // },
          splitLine: {
            show: true,
            lineStyle: {
               color: 'rgba(255, 255, 255, 0.5)'

            }
          },
          axisLine: {
            show: true,
            lineStyle: {
                color: 'rgba(255, 255, 255, 0.5)'
            }
          }
        },
        series: [
          {
            data: this.nume,
            // data:[0.03,0,0.18,0.02,0.74,1.07,0.09,],
            type: 'line',
            symbol: 'none',
            smooth: true,
            itemStyle: {
                 color:'#FBE947'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(251, 233, 71, 0.6)'
                },
                {
                  offset: 1,
                  color: 'rgba(251, 233, 71, 0)'
                }
              ])
            }
          }
        ]
      }
        myEchart.setOption(option);
      },
    // setCharts(){
    //   const container = document.querySelector('.charts')
    //   const myCharts = new Charts(container)
    //   myCharts.setOption({
    //   color:['rgba(251, 233, 71, 1)'],
    //   // gird:{
    //   //   bottom:'1%',
    //   //   style:{
    //   //      width:200,
    //   //      height:1000
    //   //    }
    //   // },
    //   xAxis: {
    //     data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
    //     boundaryGap: false,
    //      axisLine:{
    //       style: {
    //           stroke: 'rgba(70, 90, 100, 1)',
    //           lineWidth: 1
    //         }
    //     },
    //     axisTick:{
    //       show:false
    //     },
    //    axisLabel:{
    //      style: {
    //           fill:'rgba(255, 255, 255, 0.5)',
    //           fontSize: 10,
    //           rotate: 0
    //         } }
    //   },
    //   yAxis: {
    //     data: 'value',
    //     axisLine:{
    //       style: {
    //           stroke: 'rgba(70, 90, 100, 1)',
    //           lineWidth: 1
    //         }
    //     },
    //       axisTick:{
    //       show:false
    //     },
    //     splitLine:{
    //       style: {
    //         stroke: 'rgba(70, 90, 100, 1)',
    //         lineWidth: 1
    //       }
    //     },
    //     axisLabel:{
    //      style: {
    //           fill:'rgba(255, 255, 255, 0.5)',
    //           fontSize: 10,
    //           rotate: 0
    //         }
    //    }
    //   },
    //   series: [
    //     {
    //       data: this.num,
    //       type: 'line',
    //       smooth:true,
    //       lineArea: {
    //         show: true,
    //         gradient: ['rgba(251, 233, 71, 0.6)', 'rgba(251, 233, 71, 0)']
    //       },
    //       linePoint:{
    //         show:false
    //       },
    //     }
    //   ]
    //   })
    // },
    getOccupancyColor(area) {
      const state = OCCUPANCY_STATES.find((x) => x.id === area.occupancy_state);
      return state ? state.color : "";
    },
    getOccupancyIcon(area) {
      const state = OCCUPANCY_STATES.find((x) => x.id === area.occupancy_state);
      return state ? state.icon : "";
    },
  }
};
</script>

<style lang="less">
  .yellow{
    font-family: 'Furore';
      font-weight: 400;
         font-size: 30px;
         color:#FBE947
   }
   .gary{
      font-family: -apple-system,SF UI Text,Arial,PingFang SC,Hiragino Sans GB,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif;
      font-size: 10px;
      color:rgba(155, 163, 170, 1) ;
   }
   .write{
      font-family: -apple-system,SF UI Text,Arial,PingFang SC,Hiragino Sans GB,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif;
      font-size: 13px;
      color:rgba(255, 255, 255, 255) ;
      font-weight: 700;
    }
#phone-container {
  width: 96.5%;
  height: 100%;
  position: relative;
  // background: rgba(26, 27, 51, 0.6);
  margin: 0 auto;
  // background-color: pink;
  display: flex;
  justify-content: space-between;
  .daylv{
    width: 57%;
    height: 100%;
    background-color: red;
    background: url(./img/meetingday.png) no-repeat;
    // background-size: cover;
    background-size: 627px 350px;
    background-position: left -17px bottom -20px;
    display: flex;
    .charts{
      height: calc(~"100% - 66px - 9px") !important;
      // background-color: green;
      width:66% ;
      margin: 70px 10px 10px 16px;
      
    }
    .chong{
      height: calc(~"100% - 75px - 9px") !important;
      width:25%;
      background-color: rgba(255, 255, 255, 0.05);
      margin: 70px 0px 20px 10px;
      display: flex;
      flex-direction: column;
      img{
        width: 65%;
        margin: 0 auto;
      }
     .chonglv{
      //  background-color: pink;
       height: 50%;
       display: flex;
       align-items: center;
       justify-content: center;
       flex-direction: column;
       .yellow{
         font-family: 'Furore';
       }
     }
     .chongchang{
      //  background-color: red;
       height: 50%;
       display: flex;
       align-items: center;
       justify-content: center;
       flex-direction: column;
     }
    }
  }
  .worktime{
    width: 40%;
    height: 100%;
    background:url(./img/workday.png) no-repeat;
    background-size: 458px 351px;
    background-position: left -21px bottom -20px;
    position: relative;
    // padding-top: 20px;
    .swiper{
     height: calc(~"105% - 154px - 9px") !important;
     width: 90%;
     position: absolute;
     margin:70px 10px 10px 21px;
     padding-top: 40px;
       .swiper-slide {
          background: transparent;
          height: 300px;
          position: relative;
          .zhan{
            display: flex;
            justify-content: space-between;
          }
          .aaa{
            width:100%;
            background-color: rgba(255, 255, 255, 0.05);
            height: 10px;
            margin-top: 7px;
          }
          .bbb{
              //  background-color: linear-gradient(270deg, #18FEFE -0.07%, #189DFE 100%);
              background: linear-gradient(270deg, #18FEFE -0.07%, #189DFE 100%);
              // background-color: red;
               width: 100%;
               height: 10px;
               position: absolute;
               top:27px
          }
     }

    }
  }
  // .phone-booth-header {
  //   height: 58px;
  //   background: #e30613;
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: center;
  //   padding: 10px 30px;
  //   margin-bottom: 12px;
  //   span:nth-of-type(1) {
  //     font-size: 20px;

  //     font-weight: bold;
  //     color: #ffffff;
  //   }
  //   span:nth-of-type(2) {
  //     font-size: 16px;

  //     font-weight: bold;
  //     color: rgba(255, 255, 255, 0.6);
  //   }
  // }

  // .phone-booth-content {
  //   width: calc(100% - 18px);
  //   height: calc(~"100% - 78px - 9px") !important;
  //   display: flex;
  //   flex-wrap: wrap;
  //   padding: 0 9px 9px;
  //   .phone-item {
  //     width: calc(25% - 18px - 18px);
  //     height: calc(50% - 18px);
  //     color: #ffffff;
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     flex-direction: column;
  //     margin: 9px;
  //     padding: 0 9px;
  //     // img {
  //     //   width: 16px;
  //     //   height: 16px;
  //     //   margin-bottom: 2px;
  //     // }
  //     // span {
  //     //   font-size: 12px;
  //     //   font-weight: 500;
  //     //   white-space: nowrap;
  //     //   text-overflow: ellipsis;
  //     //   overflow: hidden;
  //     //   width: 100%;
  //     //   text-align: center;
  //     // }
  //   }
  // }
}
</style>
